import { render, staticRenderFns } from "./VisualizationsCard.vue?vue&type=template&id=64db8170&scoped=true"
import script from "./VisualizationsCard.vue?vue&type=script&lang=js"
export * from "./VisualizationsCard.vue?vue&type=script&lang=js"
import style0 from "./VisualizationsCard.vue?vue&type=style&index=0&id=64db8170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db8170",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VDatePicker,VIcon,VMenu,VTab,VTabItem,VTabs})
